import { render } from "./usersOverflowMock.vue?vue&type=template&id=77ac0386&scoped=true&ts=true&lang=pug"
import script from "./usersOverflowMock.vue?vue&type=script&lang=ts"
export * from "./usersOverflowMock.vue?vue&type=script&lang=ts"

import "./usersOverflowMock.vue?vue&type=style&index=0&id=77ac0386&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ac0386"]])

export default __exports__